import React from "react";
import AddMerchant from "../../../Administrative/AddMerchants";

const AddMerchantBusiness = () => {
  return (
    <div>
      <AddMerchant />
    </div>
  );
};

export default AddMerchantBusiness;
